const AssignNewVideo = () => (
    <div>
        <h1>assign_new_video Under Construction</h1>
    </div>
);

export default AssignNewVideo;
